import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { TopBarInitStepDeclaration } from "./Steps/TopBarInitStep";


export const topBarStartupFlow = new FlowDefinition("TopBarFlow");

topBarStartupFlow.addStep(TopBarInitStepDeclaration);

topBarStartupFlow.setStartStep("TopBarInit_Step");

export const topBarStartupFlowDefinition = new StepDefinition({
    stepName: "TopBarFlow",
    stepFlow: topBarStartupFlow,
    contextIsolation: false
})